export class SocketMessage {
  id: string;
  subject: string;
  body: any;
}
